import { TopPharmacyBadge } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";

export function TopPharmacySection({ count }: { count: number }) {
	const { t } = useTranslation("product");
	return (
		<div
			className="flex shrink-0 items-center gap-1"
			data-testid="pharmacy-picker-top-section"
		>
			<TopPharmacyBadge />
			<span className="text-body whitespace-nowrap text-gray-700">
				{t("vendor.pdp.topPharmacies")}
			</span>
		</div>
	);
}
